import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type VerifiedUserIconProps = CommonSvgProps

const VerifiedUserIcon: React.FC<VerifiedUserIconProps> = React.forwardRef<
  SVGSVGElement,
  VerifiedUserIconProps
>((props, ref) => (
  <Svg viewBox="0 0 79 84" {...props} ref={ref} color="none">
    <path
      d="M3 66.2731C3.68757 59.7036 12.0759 42.3413 31.8779 42.3413C51.6798 42.3413 60.0682 60.6421 60.0682 66.2731"
      stroke="#51565C"
      strokeWidth="4.41818"
      strokeLinecap="round"
    />
    <circle cx="30.6146" cy="16.5682" r="14.3591" stroke="#51565C" strokeWidth="4.41818" />
    <circle
      cx="58.9635"
      cy="63.3273"
      r="17.6727"
      fill="white"
      stroke="#51565C"
      strokeWidth="4.41818"
    />
    <path
      d="M65.5911 57.8046L64.0337 56.2472L57.0308 63.25L58.5882 64.8074L65.5911 57.8046ZM70.2743 56.2472L58.5882 67.9333L53.9712 63.3273L52.4138 64.8847L58.5882 71.0591L71.8428 57.8046L70.2743 56.2472ZM46.1621 64.8847L52.3365 71.0591L53.8939 69.5017L47.7306 63.3273L46.1621 64.8847Z"
      fill="#53A2D9"
    />
  </Svg>
))

VerifiedUserIcon.propTypes = commonPropTypes
VerifiedUserIcon.defaultProps = commonDefaultProps

export default VerifiedUserIcon
